const loader = (p) => {
  try {
    const el = document.getElementById('loader');
    if (!el) return;
    if (p) {
      el.classList.remove('d-none');
    } else {
      el.classList.add('d-none');
    }
  } catch (e) {
    // Fail silently if element not present
  }
};

export default loader;